import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import cancelIcon from "../../../Assets/cross.png";
import Styles from "./OrderStatusmodal.module.css";
import { approvalStatusServices } from "../../../Services/ApiServices";
import toast from "react-hot-toast";
import Loader from "../../../SharedComponents/Loader/Loader";
import { useFormik } from "formik";
export default function KansasApprovelConfirmationmodal({
  isOpen,
  onHide,
  handleSubmit,
  approvalStatusId,
  listapicall,
  approveStatusType,
}) {
  const [isLoader, setIsLoader] = useState(false);
  const [reason, setReason] = useState("");
  const handleApprovalStatus = () => {
    setIsLoader(true);
    let formData = new FormData();
    formData.append("purchase_id", approvalStatusId?.purchase_id);
    formData.append("approval_status", approveStatusType);
    if (reason) {
      formData.append("reason", reason);
    }
    approvalStatusServices(formData)
      .then((res) => {
        listapicall();
        toast.success(res.data.msg, { type: "success" });

        onHide();
        // resetForm();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong !!", { type: "error" });
        }
      })
      .finally(() => {
        setIsLoader(false);
      });
  };
  return (
    <div>
      <Loader isLoader={isLoader} />
      <Modal
        size="md"
        show={isOpen}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className={Styles.cancelImgParentContainer}>
            <div>
              <p className="fontBold">
                {approveStatusType === 1 ? (
                  <span className="orange">Accept</span>
                ) : (
                  <span className="orange">Reject</span>
                )}
              </p>
            </div>
            <div className={Styles.cancelImgContainer}>
              <img
                onClick={onHide}
                src={cancelIcon}
                alt="cancel"
                className={Styles.cancelImg}
              />
            </div>
          </div>
          {approveStatusType === 1 ? (
            <div className={Styles.confirmationtextdisplay}>
              <p className={Styles.confirmationText}>
                Are you sure accept this customer Request ?
              </p>
            </div>
          ) : (
            <div className={Styles.confirmationtextdisplay}>
              <p className={Styles.confirmationText}>
                Are you sure reject this customer Request ?
              </p>
            </div>
          )}
          {approveStatusType === 2 ? (
            <>
              {/* <label className="label">Reason</label> */}
              <div>
                <textarea
                  className={Styles.textarea + " contentFont"}
                  type="text"
                  name="reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Enter Reason"
                />
              </div>
            </>
          ) : null}
          <div className={Styles.btnContainer}>
            {/* <button onClick={resetForm} className={Styles.Resetbtn}>
              Reset
            </button> */}
            <button onClick={handleApprovalStatus} className={Styles.btn}>
              {approveStatusType === 1 ? " Accept" : "Reject"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
